/**
 * sentry 忽略的错误
 * 注意，如果字符串中包含正则的特殊字符（[.*+?^${}()|[\]\\]），需要转义
 * // https://blog.sentry.io/making-your-javascript-projects-less-noisy/#ignore-un-actionable-errors
 */
export var ignoreErrors = [
    /您取消了请求/gi,
    /Request failed with status code 4/gi,
    /Request failed with status code 5/gi,
    /Failed to fetch/gi,
    /ResizeObserver/gi,
    'ResizeObserver loop completed',
    'ResizeObserver loop limit exceeded',
    /Cannot read properties of undefined \(reading 'Q'\)/gi,
    /Cannot read properties of null \(reading 'removeChild'\)/gi,
    /Cannot read property 'Q' of undefined/gi,
    /Cannot read property 'removeChild' of null/gi,
    /promise rejection captured/gi,
    'ChunkLoadError',
    /Loading( CSS)? chunk (.+) failed/gi,
    /Cannot read property 'path' of undefined/gi,
    /Unable to preventDefault inside passive event listener invocation/gi,
    /Network Error|NetworkError|Request aborted|Load failed|已取消/gi,
    /Unexpected token '<'/gi,
    /timeout of 30000ms exceeded/gi,
    /You need to export lifecycle functions in lhbMicroPms entry/gi,
    /Cannot redefine property: \$bus/gi,
    /https:\/\/webapi\.amap\.com/gi,
    /map\.baidu\.com/gi,
].map(function (item) { return item instanceof RegExp ? item : new RegExp(item, 'gi'); });
